import React, { PureComponent } from 'react';
import { Row, Col, Glyphicon, Button } from 'react-bootstrap';
import InputComponent from '../../components/baseComponents/input';

class UsersSearchBar extends PureComponent {
  state = {
    keyword: '',
  }

  componentDidMount () {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  resetKeyWordInput = () => {
    this.setState({
      keyword: '',
    });
  }

  handleInputChange = (val, name) => {
    this.setState({[name]: val});
    this.props.onSearch(val);
  }

  searchKeyword = () => {
    this.props.onSearch(this.state.keyword);
  };
  render () {
    const {
      keyword,
    } = this.state;

    return (
      <Row className="search-bar-row">
        <Col sm={12}>
          <div className="input-group">
            <InputComponent
              value={keyword}
              inputGroup="keyword"
              placeholder='Search for...'
              classes='form-control'
              onChange={this.handleInputChange}
            />
            <span className="input-group-btn">
              <Button 
                onClick={this.searchKeyword.bind()}
                type="button"
              >
                <Glyphicon glyph="search" />
              </Button>
            </span>
          </div>
        </Col>
      </Row>
    );
  }
}

export default UsersSearchBar;


// WEBPACK FOOTER //
// ./src/app/screens/users/usersSearchBar.js